/* eslint-disable */
import React from 'react'
import http from '../Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import {accounting} from 'accounting'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import moment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import SearchCustomer from '../BaseComponent/SearchCustomer'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import CRM from '../BaseComponent/CRM'
import {convertMonth, genderType} from '../utils/convert'
import FromToPicker from '../BaseComponent/FromToPicker'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'

class Club extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      printInfo: [],
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      buttonClicked: false,
      club: [],
      fromDate: '',
      toDate: '',
      sortBy: 'countAll_desc',
      fromPrintDate: '',
      toPrintDate: '',
      customerCode: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام',
          value: 'firstName',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'نام خانوادگی',
          value: 'lastName',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'کد مشتری',
          value: 'customerCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'جنسیت',
          value: 'gender',
          sorted: true,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ تولد',
          value: 'customerBirthDate',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ ثبت نام',
          value: 'customerRegisterDate',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'نام کاربری',
          value: 'username',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تلفن',
          value: 'telephone',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'موبایل',
          value: 'mobile',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد خرید',
          value: 'countAll',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'کمیسیون',
          value: 'commAll',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'سود',
          value: 'profitAll',
          sorted: true,
          direction: null,
          sortable: true
        }
      ],
      columns: [],
      validMonth: []
    }
  }

  getClubReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    return http
      .get(`${CRM.CRM_PUBLIC_REPORT_RETAIL_CUSTOMER_CLUB_MASTER}`, {
        params: filter
      })
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            tablePageNumber: this.state.pageNumber,
            tablePageSize: this.state.pageSize,
            club: response.data.object.result,
            countAll: response.data.object.countAll,
            buttonClicked: true
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            club: [],
            countAll: 0
          })
          // message.error(response.data.description)
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }
  getMounts = () => {
    let filter = {}
    let invoiceDateMin = this.state.fromDate
    let invoiceDateMax = this.state.toDate
    let customerRegisterDateMax = this.state.registerDateTo
    let customerRegisterDateMin = this.state.registerDateFrom
    if (invoiceDateMin === '') {
      if (customerRegisterDateMin !== '') {
        filter.from = customerRegisterDateMin
      }
    } else if (customerRegisterDateMin === '') {
      filter.from = invoiceDateMin
    } else if (invoiceDateMin < customerRegisterDateMin) {
      filter.from = customerRegisterDateMin
    } else {
      filter.from = invoiceDateMin
    }

    if (customerRegisterDateMax === '') {
      if (invoiceDateMax !== '') {
        filter.to = invoiceDateMax
      }
    } else if (invoiceDateMax === '') {
    } else if (customerRegisterDateMax > invoiceDateMax) {
      filter.to = invoiceDateMax
    } else {
      filter.to = invoiceDateMax
    }

    return http
      .get(`${BASE_MANAGE.BASE_SYSTEM_TIMESTAMPTOMOUNTINVERVAL}`, {
        params: filter
      })
      .then((res) => {
        let months = res.data.object
        let validMonth = []
        months.forEach((item) => {
          validMonth.push({
            key: item,
            translateKey: convertMonth(item.substring(5, 7)) + '  ' + item.substring(0, 4),
            sortable: true,
            direction: null,
            sorted: false,
            sortType: null
          })
        })
        let arrayOfColumns = []
        months.forEach((item) => {
          arrayOfColumns.push({
            sort: false,
            direction: null,
            key: item
          })
        })
        this.setState({
          validMonth,
          columns: arrayOfColumns
        })
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  handleChangeRegisterFromDate = (registerDateFrom) => {
    this.setState({
      registerDateFrom
    })
  }

  handleChangeRegisterToDate = (registerDateTo) => {
    this.setState({
      registerDateTo
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let customerCode = this.state.customerCode
    let invoiceDateMin = this.state.fromDate
    let invoiceDateMax = this.state.toDate
    let customerRegisterDateMax = this.state.registerDateTo
    let customerRegisterDateMin = this.state.registerDateFrom
    let customerUsername = document.getElementById('customerUsername').value.trim()

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (customerCode !== '') {
      filter.customerCode = customerCode
    }
    if (invoiceDateMin !== '') {
      filter.invoiceDateMin = invoiceDateMin
    }
    if (invoiceDateMax !== '') {
      filter.invoiceDateMax = invoiceDateMax
    }
    if (customerRegisterDateMax !== '') {
      filter.registerDateMax = customerRegisterDateMax
    }
    if (customerRegisterDateMin !== '') {
      filter.registerDateMin = customerRegisterDateMin
    }
    if (customerUsername !== '' && customerUsername.length) {
      filter.customerUsername = customerUsername
    }

    return filter
  }

  filter() {
    this.setState({
      loading: true
    })
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      Promise.all([this.getMounts()]).then(() => {
        this.setState(
          {
            pageNumber: 1
          },
          () => {
            this.getClubReport(false)
          }
        )
      })
    }
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_RFML}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            countAll: response.data.object.countAll,
            loading: false
          })

          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
          // message.error(response.data.description)
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })
    http
      .get(`${CRM.CRM_PUBLIC_REPORT_RETAIL_CUSTOMER_CLUB_MASTER}`, {
        params: filter
      })
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          let result = response.data.object.result
          this.convertCsv(result, 'گزارش باشگاه مشتریان', true)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  createArrayOfMountForCsv = (validMount) => {
    let array = []
    validMount.forEach((item) => {
      array.push(`تعداد خرید ${item.translateKey}`, `کمیسیون ${item.translateKey}`, `سود ${item.translateKey}`)
    })
    return array
  }

  getDynamicValueOfDynamicColumn = (object) => {
    for (let key in object) {
      return object[key]
    }
  }

  convertCsv = (JSONData, ReportTitle, ShowLabel) => {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData
    var CSV = ''
    //Set Report title in first row or line

    CSV += ReportTitle + '\r\n\n'

    //This condition will generate the Label/Header
    if (ShowLabel) {
      var row = ''
      let dynamicCol = this.createArrayOfMountForCsv(this.state.validMonth).reverse()
      let staticCol = [
        'نام',
        'نام خانوادگی',
        'کدمشتری',
        'جنسیت',
        'تاریخ تولد',
        'تاریخ ثبت نام',
        'نام کاربری',
        'تلفن',
        'موبایل',
        'جمع تعداد خرید',
        'جمع کمیسیون',
        'جمع سود'
      ]
      let allCol = staticCol.concat(dynamicCol)
      //This loop will extract the label from 1st index of on array
      for (var index in allCol) {
        //Now convert each value to string and comma-seprated
        row += allCol[index] + ','
      }

      row = row.slice(0, -1)

      //append Label row with line break
      CSV += row + '\r\n'
    }

    //1st loop is to extract each row
    let dataRow = []
    console.log(arrData)
    arrData.forEach((item, index) => {
      let obj = {
        firstName: item.customer.firstName,
        lastName: item.customer.lastName,
        userCode: item.customer.userCode,
        gender: genderType(item.customer.gender),
        birthDate: item.customer.birthDate !== null ? jMoment(item.customer.birthDate).format('jYYYY/jMM/jDD') : '',
        registerDate:
          item.customer.registerDate !== null ? jMoment(item.customer.registerDate).format('jYYYY/jMM/jDD') : '',
        username: item.customer.username,
        telephone: item.customer.telephone,
        mobile: item.customer.mobile,
        countAll: item.countAll,
        commAll: item.commAll,
        profitAll: item.profitAll
      }

      // for(let i = 0 ; i < Object.keys(item.countMonths).length; i++){
      //     // for(let key in item.countMonths){
      //     //     console.log(item.countMonths[key])
      //     //     console.log(item.countMonths)
      //     // }
      //     console.log(item.countMonths[i][key] , " : " , item.countMonths[i])
      // }
      for (let key in item.countMonths) {
        console.log(key + ' : ' + item.countMonths[key])
        obj['سود' + key] = item.profitMonths[key]
        obj['کمیسیون' + key] = item.commMonths[key]
        obj['تعداد' + key] = item.countMonths[key]
      }

      dataRow.push(obj)
    })
    for (var i = 0; i < dataRow.length; i++) {
      var row = ''
      //2nd loop will extract each column and convert it in string comma-seprated
      for (var index in dataRow[i]) {
        row += '"' + dataRow[i][index] + '",'
      }
      row.slice(0, row.length - 1)
      //add a line break after each row
      CSV += row + '\n'
    }

    if (CSV == '') {
      alert('Invalid data')
      return
    }

    //Generate a file name
    var fileName = '_'
    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName += ReportTitle.replace(/ /g, '_')

    //Initialize file format you want csv or xls
    var uri = 'data:text/csv;charset=utf-8,%EF%BB%BF,' + encodeURI(CSV)

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension

    //this trick will generate a temp <a /> tag
    var link = document.createElement('a')
    link.href = uri

    //set the visibility hidden so it will not effect on your web-layout
    link.style = 'visibility:hidden'
    link.download = fileName + '.csv'

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getClubReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getClubReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getClubReport(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  getSingleCustomerCode = (customerCode) => {
    this.setState({
      customerCode
    })
  }

  sortComplex = (type, value, index, direction) => {
    let {validMonth, sortData} = this.state
    if (direction === null) {
      for (let i = 0; i < validMonth.length; i++) {
        validMonth[i].sorted = false
        validMonth[i].direction = null
      }
      validMonth[index].sorted = true
      validMonth[index].direction = '1'
      validMonth[index].sortType = type
      let sortColumn = value.replace('_', '/')
      let sortType = '_desc'
      let sort = type + sortColumn + sortType
      this.setState({validMonth, sortBy: sort})
    } else if (direction === '1') {
      for (let i = 0; i < validMonth.length; i++) {
        validMonth[i].sorted = false
        validMonth[i].direction = null
      }
      validMonth[index].sorted = true
      validMonth[index].sortType = type

      validMonth[index].direction = '2'
      let sortColumn = value.replace('_', '/')
      let sortType = '_asc'
      let sort = type + sortColumn + sortType
      this.setState({validMonth, sortBy: sort})
    } else if (direction === '2') {
      for (let i = 0; i < validMonth.length; i++) {
        validMonth[i].sorted = false
        validMonth[i].direction = null
      }
      validMonth[index].sorted = true
      validMonth[index].sortType = type

      validMonth[index].direction = '1'
      let sortColumn = value.replace('_', '/')
      let sortType = '_desc'
      let sort = type + sortColumn + sortType
      this.setState({validMonth, sortBy: sort})
    }

    sortData.forEach((item) => {
      item.direction = null
    })
    this.setState({
      sortData
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'کد مشتری',
      'نام و نام خانوادگی',
      'نام کاربری',
      'تاریخ ثبت نام',
      'تاریخ آخرین خرید',
      'فاصله آخرین خرید تا کنون(روز)',
      'فاصله اولین خرید از ثبت نام تا کنون(روز)',
      'تعداد کل خرید',
      'حجم کل خرید',
      'میانگین فاصله خرید ها',
      'میانگین تعداد سطر فاکتور'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش سابقه خرید مشتریان"
              headerColSpan={12}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={5}
              centerColSpan={3}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((rfml, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{rfml.customer.userCode}</td>
                  <td>{rfml.customer.name}</td>
                  <td>{rfml.customer.username === null ? '-' : rfml.customer.username.replace(/\+98/g, '0')}</td>
                  <td>{jMoment(rfml.registerDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>
                    {rfml.lastPurchaseDate === null ? '-' : jMoment(rfml.lastPurchaseDate).format('jYY/jM/jD HH:mm')}
                  </td>
                  <td>{rfml.distanceLastPurchaseToNow}</td>
                  <td>{rfml.distanceRegisterToFirstPurchase}</td>
                  <td>{rfml.purchaseCount}</td>
                  <td className="priceCell">{accounting.formatMoney(rfml.totalAmount, '', ',')}</td>
                  <td>{rfml.distanceAverage}</td>
                  <td>{rfml.invoiceItemCountAverage}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>باشگاه مشتریان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                {/*<button*/}
                {/*    className="printButton"*/}
                {/*    disabled={this.state.buttonClicked ? false : true}*/}
                {/*    onClick={this.exportPrint}*/}
                {/*>*/}
                {/*    <i className="fas fa-print"></i>*/}
                {/*</button>*/}
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <SearchCustomer
                  label={'کد مشتری'}
                  getSingleCustomerCode={this.getSingleCustomerCode}
                  singleResult={true}
                  searchLabel={'جست و جوی مشتری'}
                />

                <div className="formComponent">
                  <label>نام کاربری مشتری:</label>
                  <input type="text" className="form-control" id="customerUsername" name="customerUsername" />
                </div>
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ثبت فاکتور از"
                  toLabel="تاریخ ثبت فاکتور تا"
                  fromId="from"
                  toId="to"
                  defaulValue
                />
                <FromToPicker
                  onChangeFromDate={this.handleChangeRegisterFromDate}
                  onChangeToDate={this.handleChangeRegisterToDate}
                  fromLabel="تاریخ ثبت نام از"
                  toLabel="تاریخ ثبت نام تا"
                  fromId="fromReg"
                  toId="toReg"
                />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <div className="overflow-auto">
                <table className="baseTable">
                  <tbody>
                    <tr>
                      <td colSpan={10} className="font-weight-bold">
                        مشخصات مشتری
                      </td>
                      <td colSpan={3} className="font-weight-bold">
                        جمع
                      </td>
                      {/*<td className='font-weight-bold' colSpan={this.state.validMonth.length * 2}>*/}
                      {/*    */}
                      {/*</td>*/}
                      {this.state.validMonth.map((item, num) => (
                        <td colSpan={3}>
                          <span className="font-weight-bold" dir={'rtl'}>
                            <span>{item.translateKey}</span>
                          </span>
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <Sort extendedHeader data={this.state.sortData} getSort={this.getSort} />
                      {this.state.validMonth.map((item, num) => (
                        <>
                          <td onClick={() => this.sortComplex('count', item.key, num, item.direction)}>
                            تعداد خرید
                            <span className="position-relative">
                              {item.direction === null && item.sortable && (
                                <span className="m-3 sortAnggle" style={{color: '#b0b0b0'}}>
                                  <i className="fas fa-sort" />
                                </span>
                              )}
                              {item.direction === '2' && item.sortType === 'count' && (
                                <span className="m-3  sortAnggle">
                                  <i className="fas fa-caret-up" />
                                </span>
                              )}
                              {item.direction === '1' && item.sortType === 'count' && (
                                <span className="m-3  sortAnggle">
                                  <i className="fas fa-caret-down" />
                                </span>
                              )}
                            </span>
                          </td>
                          <td onClick={() => this.sortComplex('comm', item.key, num, item.direction)}>
                            کمیسیون
                            <span className="position-relative">
                              {item.direction === null && item.sortable && (
                                <span className="m-3 sortAnggle" style={{color: '#b0b0b0'}}>
                                  <i className="fas fa-sort" />
                                </span>
                              )}
                              {item.direction === '2' && item.sortType === 'comm' && (
                                <span className="m-3  sortAnggle">
                                  <i className="fas fa-caret-up" />
                                </span>
                              )}
                              {item.direction === '1' && item.sortType === 'comm' && (
                                <span className="m-3  sortAnggle">
                                  <i className="fas fa-caret-down" />
                                </span>
                              )}
                            </span>
                          </td>
                          <td onClick={() => this.sortComplex('profit', item.key, num, item.direction)}>
                            سود
                            <span className="position-relative">
                              {item.direction === null && item.sortable && (
                                <span className="m-3 sortAnggle" style={{color: '#b0b0b0'}}>
                                  <i className="fas fa-sort" />
                                </span>
                              )}
                              {item.direction === '2' && item.sortType === 'profit' && (
                                <span className="m-3  sortAnggle">
                                  <i className="fas fa-caret-up" />
                                </span>
                              )}
                              {item.direction === '1' && item.sortType === 'profit' && (
                                <span className="m-3  sortAnggle">
                                  <i className="fas fa-caret-down" />
                                </span>
                              )}
                            </span>
                          </td>
                        </>
                      ))}
                    </tr>
                    {this.state.club.map((club, index) => (
                      <tr key={index}>
                        <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                        <td>{club.customer.firstName}</td>
                        <td>{club.customer.lastName}</td>
                        <td>
                          <Link target="_blank" to={`/club/customer/reportCard?customerCode=${club.customer.userCode}`}>
                            {club.customer.userCode}
                          </Link>
                        </td>
                        <td>{genderType(club.customer.gender)}</td>
                        <td>
                          {club.customer.birthDate !== null && jMoment(club.customer.birthDate).format('jYYYY/jMM/jDD')}
                        </td>
                        <td>
                          {club.customer.registerDate !== null &&
                            jMoment(club.customer.registerDate).format('jYYYY/jMM/jDD')}
                        </td>
                        <td>{club.customer.username === null ? '-' : club.customer.username.replace(/\+98/g, '0')}</td>
                        <td>{club.customer.telephone}</td>
                        <td>{club.customer.mobile === null ? '-' : club.customer.mobile.replace(/\+98/g, '0')}</td>
                        <td>{club.countAll}</td>
                        <td>{accounting.formatMoney(club.commAll, '', ',')} ریال </td>
                        <td>{accounting.formatMoney(club.profitAll, '', ',')} ریال </td>
                        {this.state.columns.map((item) => (
                          <>
                            <td style={{borderRight: '2px solid black'}}>{club.countMonths[item.key]}</td>
                            <td>{accounting.formatMoney(club.commMonths[item.key], '', ',')} ریال </td>
                            <td>{accounting.formatMoney(club.profitMonths[item.key], '', ',')} ریال </td>
                          </>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Club
